import styled from "styled-components";

export const Wrapper = styled.div`
  background: ${(props) => props.theme.background_grey};
  width: 100%;
  height: 100%;
  position: relative;

  .close-btn {
    width: 20px;
    height: 20px;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 10px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 12px 20px 0px 20px;
  

  @media screen and (max-width: 600px) {
    padding: 10px 20px;
  }
  .sign_in_link_text {
    width: 388px;
    font-family: ${(props) => props.theme.textFont};
    margin-bottom: 2rem;
    font-size: 14px;
    @media screen and (max-width: 600px) {
      width: 200px;
      font-size: 10px;
    }
    span {
      color: ${({ theme }) => theme.link_color};
      font-family: ${(props) => props.theme.textFont};
      font-size: 13px;
      text-decoration: underline;
    }
  }
`;

export const FormTitle = styled.h4`
  font-family: ${(props) => props.theme.textFont};
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: ${(props) => props.theme.text_black};
  width: 388px;
  @media screen and (max-width: 600px) {
    width: 250px;
    padding-left: 10px;
    font-size: smaller;
  }
`;
export const FormSubText = styled.small`
  font-family: ${(props) => props.theme.textFont};
  font-size: 14px;
  width: 388px;
  @media screen and (max-width: 600px) {
    width: 250px;
    padding-left: 12px;
    font-size: 10px;
  }
  small {
    color: ${({ theme }) => theme.link_color};
    font-family: ${(props) => props.theme.textFont};
    font-size: 14px;
    text-decoration: underline;
    @media screen and (max-width: 600px) {
      width: 90%;
      font-size: 10px;
    }
  }
`;
export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .input_wrapper {
    display: flex;
    position: relative;

    svg {
      position: absolute;
      top: 20px;
      right: 10px;
      width: 20px;
      height: 20px;
    }
  }
  @media screen and (max-width: 600px) {
    width: 90%;
  }

  .error {
    color: red;
    opacity: 0.7;
  }
`;
export const InputLabel = styled.label`
  font-family: ${(props) => props.theme.textFont};
  font-weight: 500;
  font-style: normal;
  font-size: 15px;
  color: #252525;
  margin-top: 10px;
  @media screen and (max-width: 600px) {
    font-size: 10px;
  }
`;
export const FormInput = styled.input`
  width: 100%;
  height: 44px;
  margin-top: 10px;
  border: 1px solid #dedede;
  border-radius: 3px;
  padding-left: 15px;
  font-family: Mulish;
  font-weight: 400;
  font-size: 14px;
  color: rgba(115, 123, 125, 1);

  &:focus {
    outline: 0px;
  }

  @media screen and (max-width: 600px) {
    height: 30px;
    font-size: smaller;
    padding-top: 10px;
    padding-bottom: 10px;
    max-width: 250px;

    &::placeholder {
      font-size: 10px;
    }
  }
`;

export const SubmitButton = styled.button`
  width: 388px;
  height: 54px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-family: ${(props) => props.theme.textFont};
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  border: 0px;
  cursor: pointer;

  &:focus {
    outline: 0px;
  }
  @media screen and (max-width: 600px) {
    width: 90%;
    height: 30px;
    padding: 10px 0px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  &:focus {
    outline: none;
  }
`;
